import type { Editor } from 'slate'
import type { CustomEditor } from 'modules/community/types/custom-editor'

export const withLinks = (editor: Editor): CustomEditor => {
  const { isInline } = editor
  editor.isInline = element => {
    return element.type === 'link' ? true : isInline(element)
  }
  return editor
}
